import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable, Subscriber } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Events, Platform } from 'ionic-angular';
import { map } from "rxjs/operators";

import _ from 'lodash';
import { MemberApi } from '../../../shared/sdk-budget';
import { MenuAuth } from './auth';
import { ApiServiceProvider } from '../../services/api/api-service';
import { AppPreferences } from '../../../shared/local/app-preferences.local'; // Need Dependency - PageBuilder
import { GDAuthInterface } from '../../../model/gd-auth'; // Need Dependency - PageBuilder
import { ResponseProfileDto } from '../../../shared/nestjs/gd-only/dto/auth.dto';
import { AuthApi } from '../../../shared/nestjs/gd-only/services/auth.api';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { GlobalServiceProvider } from '../../../providers/global-service/global-service';
import { AccessManagementApiProvider } from '../../../shared/nestjs/access-management/access-management-api';
import { LoopBackConfig, SunfishApi } from "../../../shared/sdk";
import moment from "moment";
import { BuilderApi } from '../../../shared/nestjs/builder/builder.api';

/**
   * Crated by Hendi, 16 Sep 2019.
  */
@Injectable()
export class PageBuilderMenuProvider {

  private FAVORITE_MENU_KEY = 'GDFavoriteMenu'
  private FILTERED_MENU_KEY = 'GDFilteredMenu';
  private ISS_MENU_KEY = 'GDIssMenu';
  private SFGoAuth: any;
  private SFGoStorage: any;
  private oldPATHUrl: any;
  private newPATHUrl: any;
  private isLoadingMenu = false;

  public builderMenus: any;

  constructor(
    private storage: Storage,
    private http: Http,
    private platform: Platform,
    private builderApi: BuilderApi,
    private apiServiceProvider: ApiServiceProvider,
    private memberApi: MemberApi,
    private appPreferences: AppPreferences,
    private authApi: AuthApi,
    private accessmanagementApi: AccessManagementApiProvider,
    private nestApiProvider: NestApiProvider,
    private globalServiceProvider: GlobalServiceProvider,
    private sunfishApi: SunfishApi,
    private events: Events,
  ) {
    this.getStorage();
  }

  /**
   * Get favorite menu
  */
  getFavoriteMenu(): Promise<any> {
    return new Promise((resolve) => {
      this.storage.ready().then(() => {
        this.storage.get(this.FAVORITE_MENU_KEY)
          // handle if success only
          .then(async favMenus => {
            if (favMenus) {
              const favMenusResult = (typeof favMenus == 'string') ? JSON.parse(favMenus) : favMenus;
              resolve(favMenusResult);
            } else {
              let getFileMenu = 'assets/pagebuilder/menu/menu-favorite.json';
              this.http.get(getFileMenu)
                .subscribe(async result => {
                  const favMenusInit = result.json();
                  const funcAuthFavMenus = await this.funcAuthFavoriteMenu(favMenusInit);
                  this.storage.set(this.FAVORITE_MENU_KEY, JSON.stringify(funcAuthFavMenus)) // save to local storage

                  resolve(funcAuthFavMenus);
                });
            }
          })
      });
    });
  }

  /**
   * Get favorite menu
  */
  async getReFavoriteMenu(): Promise<any> {
    try {
      const store = await this.storage.get(this.FAVORITE_MENU_KEY);
      if (store) {
        let getFileMenu = 'assets/pagebuilder/menu/menu-favorite.json';
        const result = await this.http.get(getFileMenu).toPromise();
        const favMenusInit = result.json();
        const funcAuthFavMenus = await this.funcAuthFavoriteMenu(favMenusInit);
        this.storage.set(this.FAVORITE_MENU_KEY, JSON.stringify(funcAuthFavMenus));
      }
    } catch (error) {
    }
  }

  /**
   * Update favorite menu
  */
  updateAuthFavoriteMenu(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let favMenus = await this.storage.get(this.FAVORITE_MENU_KEY);
        if (favMenus) {
          const favMenusResult = JSON.parse(favMenus);
          const funcAuthfavMenus = await this.funcAuthFavoriteMenu(favMenusResult);
          this.storage.set(this.FAVORITE_MENU_KEY, JSON.stringify(funcAuthfavMenus));
          resolve(favMenusResult);
        }
        else {
          resolve(true);
        }
      }
      catch (error) {
        resolve(true)
      }
    });
  }

  /**
  * Get menu page builder
  */
  getMenu(): Observable<any> {
    return new Observable(observer => {

      // Load menu from local storage if any
      this.updateMenu(observer);

      // Load menu from server
      if (this.isLoadingMenu) {
        return;
      }
      this.isLoadingMenu = true;
      this.loadMenuPageBuilderRemote().then(serverMenus => {
        this.isLoadingMenu = false;

        if (serverMenus.constructor.name == "Array") {
          this.remoteMenuSuccessHandler(observer, serverMenus);
        } else {
          this.remoteMenuErrorHandler(observer);
        }
      })
        .catch(err => {
          this.isLoadingMenu = false
          this.remoteMenuErrorHandler(observer);
        });
    });
  }

  /**
   * Check icon
   */
  isIconFile(data: any): boolean {
    // TODO parsing iconUrl check apakah dia class atau file
    if (data.iconUrl.includes("http") || data.iconUrl.includes('assets/')) {
      return true
    } else {
      return false
    }
  }

  /**
  * Clear all stored menus
  */
  clear() {
    this.builderMenus = null;
    this.storage.ready().then(() => {
      this.storage.remove(this.ISS_MENU_KEY);
      this.storage.remove(this.FILTERED_MENU_KEY);
    });
  }


  /**
   *
   * MARK: Private functions
   *
   * */


  /**
 * Get menu from local storage (cache)
 */
  private getStoredMenu(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.storage.ready().then(async () => {
        try {
          var filteredMenusRaw = await this.storage.get(this.FILTERED_MENU_KEY);
          var filteredMenus = (typeof filteredMenusRaw === 'string') ? JSON.parse(filteredMenusRaw) : filteredMenusRaw;

          // load from .json file
          if (filteredMenus === undefined || filteredMenus === null) {
            const initialMenu = await this.getMenuStandard(); // get menu from menu-standard.json
            if (initialMenu) {
              filteredMenus = await this.funcAuth(initialMenu);
              await this.storage.set(this.FILTERED_MENU_KEY, JSON.stringify(filteredMenus)) // save to local storage
            }
          }

          // iss case only
          if (this.isISS()) {
            const issMenusRaw = await this.storage.get(this.ISS_MENU_KEY);
            if (issMenusRaw) {
              const issMenus = (typeof issMenusRaw === 'string') ? JSON.parse(issMenusRaw) : issMenusRaw;
              filteredMenus = this.concatSunfishMenu(filteredMenus, issMenus);
            }
          }
          resolve(filteredMenus);
        } catch (err) {
          reject(err);
        }
      });
    });
  }

  /**
  * Handle success of menu page builder
  */
  private async remoteMenuSuccessHandler(observer: Subscriber<any>, serverMenus: any) {
    try {
      // Generate menu icon url
      for (var cat of serverMenus) {
        if (cat.items) {
          for (var item of cat.items) {
            item.iconUrl = this.generateMenuIconUrl(item.iconUrl);
          }
        }
      }

      // auth menu
      const filteredMenus = await this.funcAuth(serverMenus);
      await this.storage.set(this.FILTERED_MENU_KEY, JSON.stringify(filteredMenus)) // save to local storage

      // load iss menu
      if (this.isISS()) {
        // get iss menu
        await this.getIssMenu();
        // update ui menu
        this.updateMenu(observer);
      } else {
        // update ui menu
        this.updateMenu(observer);
      }
    } catch (err) {
      observer.error(err);
    }
  }

  /**
   * Handle error of menu page builder
   */
  private async remoteMenuErrorHandler(observer: Subscriber<any>) {
    if (this.isISS()) {
      try {
        // get iss menu
        await this.getIssMenu();
        // update ui menu
        this.updateMenu(observer);
      } catch (err) {
        observer.error(err);
      }
    }
  }

  /**
   * Check iss menu in storage and fetch from server if doesn't exists
   */
  private async getIssMenu() {
    const issMenusRaw = await this.storage.get(this.ISS_MENU_KEY);
    if (issMenusRaw === undefined || issMenusRaw === null || issMenusRaw === '') {
      // get iss menu
      const issRemoteMenus = await this.loadSunfishMenu();
      await this.storage.set(this.ISS_MENU_KEY, JSON.stringify(issRemoteMenus));
    }
  }

  /**
  * Function to update data consumed by UI
  */
  private updateMenu(observer: Subscriber<any>) {
    // load from storage
    this.getStoredMenu().then(storedMenus => {
      if (!_.isEqual(this.builderMenus, storedMenus)) {
        this.builderMenus = storedMenus;

        const copyMenusStr = JSON.stringify(this.builderMenus);
        const copyMenus = JSON.parse(copyMenusStr);
        observer.next(copyMenus);
      }
    });
  }

  /**
  * Check is iss user
  */
  private isISS(): boolean {
    if (this.SFGoAuth && this.SFGoAuth.companyCode) {
      if (
        this.SFGoAuth.companyCode.toLowerCase() == 'issid' ||
        this.SFGoAuth.companyCode.toLowerCase() == 'iss_dev' ||
        this.SFGoAuth.companyCode.toLowerCase() == 'iss_dev2'
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * Function auth for standard menus
   */
  private funcAuth(source: any): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {

      // check menu items
      if (source == undefined) {
        reject('menu undefined');
        return;
      }

      // copy object
      let menuItems: any;
      try {
        menuItems = JSON.parse(JSON.stringify(source));
      } catch (err) {
        reject('copy menu failed');
        return;
      }

      const sfGoAuth = await this.appPreferences.getAuth();
      if (sfGoAuth) {
        // check list menu
        let listMenu: any;
        try {
          listMenu = sfGoAuth.menu;
        } finally {
        }
        if (listMenu == undefined || listMenu == null) {
          reject('logout');
          return;
        }

        const isSF6 = sfGoAuth.isSF6;

        // filter menu
        for (const category of menuItems) {
          if (category.items) {
            let menuKey: any;
            let showCategory = false;
            for (const item of category.items) {

              // START - punya HR dari loadReport() yang sudah dihapus
              if (isSF6 && isSF6 == 1) {
                if (item.title == 'Claim') item.pageStatic = 'ClaimRequestSF6Page';
                else if (item.title == 'Attendance') item.pageStatic = 'TimeAttendance';
              } else {
                if (item.title == 'Claim') item.pageStatic = 'ClaimRequestPage';
                else if (item.title == 'Attendance') item.pageStatic = 'TimeAttendanceSfgoPage';
              }
              // END

              // Payroll Ionic 5
              if (item.title === 'Payroll Process') {
                if (!isSF6) {
                  item.pageStatic = 'PayrollProcessV2Page';
                }
              }

              // get menu key attr
              menuKey = MenuAuth.get(item.title);
              // filter menu
              if (category.categoryId !== 2) {
                await this.funcAuthFilterMenu(sfGoAuth, listMenu, item, menuKey, isSF6);
              } else {
                item.show = true;
              }
              // show or hide category
              if (!showCategory) showCategory = item.show;
            }
            category.show = showCategory;
          }
        }
        resolve(menuItems);
      } else {
        // Do nothing
      }
    });
  }

  /**
   * Function auth item of menu
   */
  private async funcAuthFilterMenu(sfGoAuth: GDAuthInterface, listMenu: any, menu: any, menuKey: any, isSF6: any) {
    if (menuKey == 'budget') {
      this.memberApi.isAuthenticated() ?
        menu.show = listMenu[menuKey] :
        menu.show = false;
    }
    else if (menuKey == 'payroll-payprocess') {
      !this.platform.is('cordova') ?
        menu.show = listMenu[menuKey] :
        menu.show = false;
    }
    else if (menuKey == 'chat') {
      try {
        if (sfGoAuth.socket) {
          menu.show = listMenu[menuKey];
        } else {
          menu.show = false;
        }
      } catch (error) {
        menu.show = false;
      }
    }
    else if (menuKey == 'make-id-card') {
      if (isSF6) {
        menu.show = listMenu[menuKey];
      } else {
        // GD only checking
        try {
          const res = sfGoAuth.isHRAdmin;
          if (res) {
            menu.show = listMenu[menuKey];
          } else {
            menu.show = false;
          }
        } catch (error) {
          menu.show = false;
        }
      }
    } else if (menuKey == 'payroll') {
      if (this.platform.is('cordova')) {
        menu.show = listMenu[menuKey];
      } else {
        if (sfGoAuth.companySetting.preventScreenshotPayslip) {
          menu.show = false;
        } else {
          menu.show = listMenu[menuKey];
        }
      }
    } else if (menuKey == 'itcs') {
      if (this.platform.is('cordova')) {
        menu.show = false;
      } else {
        menu.show = listMenu[menuKey];
      }
    } else if (menuKey != '') {
      menu.show = listMenu[menuKey];
    } else {
      menu.show = true; // show menu
    }
  }

  /**
   * Function auth for favorite menus
   */
  private funcAuthFavoriteMenu(source: any) {
    return new Promise(async (resolve) => {
      const sfGoAuth = await this.appPreferences.getAuth();
      let result = []
      if (sfGoAuth) {
        try {
          const isSF6 = sfGoAuth.isSF6;
          const listMenu = sfGoAuth.menu;
          const companyCode = sfGoAuth.companyCode;

          if (listMenu) {
            for (const item of source) {
              if (item.title === 'Request' && !isSF6) {
                item.show = true; // case untuk GD only menu request selalu ditampilkan
              } else if (item.title === 'Request' && isSF6) {
                item.show = (listMenu["att-leave"] || listMenu["att-correction"] || listMenu["att-overtime"] || listMenu["claim"] || listMenu["alert-menu"] || listMenu["request-menu"]) ? true : false;
              } else if (item.title === 'Benefit') {
                const exc: any = [undefined, '', null, false]
                item.show = (exc.includes(listMenu['marketplace'])) ? false : true;
              } else if (item.title === 'Payroll') {
                if (this.platform.is('cordova')) {
                  item.show = listMenu['payroll-payslip'] ? true : false;
                } else {
                  if (sfGoAuth.companySetting.preventScreenshotPayslip) {
                    item.show = false
                  } else {
                    item.show = listMenu['payroll-payslip'] ? true : false;
                  }
                }
              } else {
                const keyAttr = MenuAuth.get(item.title);
                if (keyAttr != '') {
                  item.show = (listMenu[keyAttr] == undefined) ? false : listMenu[keyAttr];
                } else {
                  item.show = false;
                }
              }

              // Overtime case only
              if (item.title === 'Overtime') {
                if (isSF6) {
                  item.pageStatic = 'OvertimeHistoryPage2SF6';
                } else {
                  item.pageStatic = 'OvertimeHistorySfgoPage';
                }
              }

              if (item.title === 'DNA Test Result') {
                item.show = listMenu['asaren-menu'] ? true : false;
              }

              if (item.title === 'Questionaire') {
                item.show = listMenu['asaren-menu'] ? true : false;
              }

              if (item.title === 'Online Doctor') {
                item.show = listMenu["yesdok"] ? true : false;
              }

              if (item.title === 'Health Form') {
                item.show = (companyCode === 'sfgo885' || companyCode === 'sfgo6822') ? true : false;
              }

              result.push(item);
            }


            resolve(result);
          }
        } catch (error) {
          console.log('TLS: error', error);
        }
      }
      else {
        resolve(true);
      }
    })
  }

  /**
   * Format icon
   */
  private generateMenuIconUrl(rawPath: any): string {
    if (rawPath) {
      let result = rawPath.replace(new RegExp('{FILE_TOKEN}', 'g'), this.SFGoAuth.id);
      if (this.newPATHUrl != undefined && this.newPATHUrl != null) {
        result = result.replace(new RegExp('{PICTURE_PATH}', 'g'), this.newPATHUrl);
      } else {
        result = result.replace(new RegExp('{PICTURE_PATH}', 'g'), this.oldPATHUrl);
      }
      return result;
    }
    return rawPath;
  }

  /**
   * Determine url from loopback or nest
   */
  private async setUrlPaths() {

    // this.newPATHUrl = 'http://localhost:30000' // local nestjs;
    // this.newPATHUrl = 'http://localhost:5000' // local loopback;
    this.newPATHUrl = null;
    this.oldPATHUrl = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion();

    if (this.SFGoStorage != undefined) {
      // set old path
      if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
        this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
      }

      // set new path
      if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin &&
        this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
        this.newPATHUrl = this.SFGoStorage.storedPrelogin.GOPATHNEW;
      }
    }
  }


  /**
  * Storage - SFGoAuth, SFGoStorage
  */
  private async getStorage() {
    try {
      this.SFGoAuth = await this.appPreferences.getAuth();
      this.SFGoStorage = await this.appPreferences.getSaasData();
      await this.setUrlPaths();
    } catch (err) { }
  }

  /**
  * Function to combine page builder menu and sf6 menu (iss)
  */
  private concatSunfishMenu(menus: any, issMenu: any): any {
    let source = JSON.parse(JSON.stringify(menus));
    let added = JSON.parse(JSON.stringify(issMenu));

    const otherIndex = source.findIndex(cat => cat.categoryId == '8'); // category other ???
    if (otherIndex != -1) {
      const foundIndex = source[otherIndex].items.findIndex(menu => menu.title == added[0].title);
      if (foundIndex == -1) { // menu not found
        source[otherIndex].items.push(...added);
      }
    } else {
      // If 'others' category not found
      var othersCat = {
        categoryId: '8',
        categoryName: 'Others',
        items: added
      };
      source.push(othersCat);
    }
    return source;
  }

  /**
   * Load menu from menu-standard.json
   */
  private getMenuStandard(): Promise<any> {
    return new Promise<String>((resolve, reject) => {
      let getFileMenu = 'assets/pagebuilder/menu/menu-standard.json';
      this.http.get(getFileMenu)
        .subscribe(result => {
          resolve(result.json());
        });
    });
  }

  /**
  * Load menu from sunfish 6 server
  */
  private async loadSunfishMenu(): Promise<any> {
    return new Promise<any>((resolve, reject) => {

      // check SFGoAuth
      if (_.isEmpty(this.SFGoAuth)) {
        return;
      }

      // set request config
      LoopBackConfig.setBaseURL(this.SFGoAuth.path);
      let method = (this.SFGoAuth.isSF6) ? "ofid=CL_AttendanceValidation.sfgoMenu" : "menu.json";
      let methodType = (this.SFGoAuth.isSF6) ? "cfc" : "nodejs";

      // request custom menu
      this.builderApi.takeCustomMenu({
        method: method,
        methodType: methodType
      }).subscribe(val => {


        // convert old menu format to new one
        var listNewMenu = Array<{ title: string, pageStatic: any, show: boolean, badgeText: string, iconUrl: string, params: any }>();
        var newMenu: { title: string, pageStatic: any, show: boolean, badgeText: string, iconUrl: string, params: any };

        for (let index = 0; index < val.length; index++) {
          const e = Object.assign({}, val[index]);
          newMenu = {
            title: e.title,
            pageStatic: e.component,
            show: true,
            badgeText: e.badgetext,
            iconUrl: e.icons,
            params: e.params
          };
          listNewMenu.push(newMenu);
        }
        resolve(listNewMenu);
      });
    });
  }

  getUserData() {
    return new Promise<ResponseProfileDto>((resolve, reject) => {
      this.apiGetUserData().subscribe((result) => {
        resolve(result)
      }, error => {
        reject(error);
      })
    })
  }

  private apiGetUserData(): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.authApi.profile().pipe(map(response => response.data))
        } else {
          return this.sunfishApi.getUserData().pipe(map(async (response) => {
            const data = await this.globalServiceProvider.convertObjToCamelCase(response.result);
            return data
          }))
        }
      })
  }

  /**
   * Load menu from page builder server
   */
  private async loadMenuPageBuilderRemote(): Promise<any> {
    await this.getStorage()
    let menus = [];

    return new Promise<any>(async (resolve, reject) => {

      if (!_.isEmpty(this.SFGoAuth)) {
        try {
          let lang = await this.storage.get('language');
          if (lang == undefined || lang == null) {
            lang = 'en'
            await this.storage.set('language', lang) // force add lang to storage
          }

          let platform;
          if (this.platform.is('cordova')) platform = 'cordova';
          else platform = 'core';

          // const urlParams = '&lang=' + lang + '&platform=' + platform;
          let accessGroup;
          try {
            accessGroup = await this.accessmanagementApi.userAccessGroup().toPromise();
            if (accessGroup && accessGroup.data) {
              this.storage.set('userAccessGroup', JSON.stringify(accessGroup.data))
            }
          } catch (error) { }

          const UserData = await this.getUserData();
          const SFGoAuth = this.SFGoAuth;
          const bodyAuth = {
            auth: {
              userData: UserData,
              isHRAdmin: SFGoAuth.isHRAdmin,
            },
            userAccess: (accessGroup) ? accessGroup.data : [],
            body: {
              platform: platform,
              lang: lang,
            },
            funcAuthMenu: {
              menu: SFGoAuth.menu,
              socket: SFGoAuth.socket,
            },
            functionAuth: this.SFGoAuth.functionAuth,
          }
          const urlBody = JSON.stringify(bodyAuth);
          const encryptedBody = await this.apiServiceProvider.sfEncrypt(urlBody);
          const body = {
            urlBody: encryptedBody,
          }
          const storeMenu = await this.storage.get(this.FILTERED_MENU_KEY);
          const initialMenu = (storeMenu) ? (typeof storeMenu === 'string') ? JSON.parse(storeMenu) : storeMenu : await this.getMenuStandard();
          this.apiServiceProvider.apiPB('POST', null, body, '/app-menu/getMenuV2?v=' + moment().format('YYYY-MM-DD'), null, true).then(async (response: any) => {
            menus = response.data || initialMenu;
            menus.map(param => {
              param.items.sort((a, b) => {
                return a.title.localeCompare(b.title);
              });
              return param;
            })
            if (response.menu) {
              this.updateMenuAuth(response.menu);
            }
            resolve(menus);
          }, error => {
            reject(error.status);
          });
        } catch (err) {
          reject(err);
        }
      } else {
        reject("SFGoAuth undefined");
      }
    });
  }

  /**
   * Load favorite menu from page builder server
   */
  // private async loadFavoriteMenuRemote(): Promise<any> {
  async loadFavoriteMenuRemote(): Promise<any> {
    await this.getStorage()
    let menus = [];
    return new Promise<any>(async (resolve, reject) => {
      if (!_.isEmpty(this.SFGoAuth)) {
        try {
          let lang = await this.storage.get('language');
          if (lang == undefined || lang == null) {
            lang = 'en'
            await this.storage.set('language', lang) // force add lang to storage
          }
          const urlParams = '&lang=' + lang;
          this.apiServiceProvider.api('GET', urlParams, null, null, '/builder/favoriteMenu', null, true).then(async (response: any) => {
            menus = response.data;
            resolve(menus);
          }, error => {
            resolve(error.status);
          });
        } catch (err) {
          reject(err);
        }
      } else {
        reject("SFGoAuth undefined");
      }
    });
  }

  // update menu auth after getMenuv2
  async updateMenuAuth(data: any) {
    try {
      const auth = await this.appPreferences.getAuth();
      if (data) {
        auth.menu = data;
        await this.appPreferences.setAuth(auth);
        await this.updateAuthFavoriteMenu();
        this.events.publish('favorite:update');
      }
    } catch (error) { }
  }

}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/menu/repository.ts